import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import WhatsAppLoginPage from "./pages/WhatsAppLoginPage";
import PartyDashboardPage from "./pages/PartyDashboardPage";
import OrdersPage from "./pages/OrdersPage";
import StockPage from "./pages/StockPage";
import LedgerPage from "./components/LedgerPage";
import StaffAccessPage from "./pages/StaffAccessPage";
import DealerMessagesPage from "./pages/DealerMessagesPage";
import ProfilePage from "./pages/ProfilePage";
import { logoutUser } from "./services/api";

function App() {
  const [dealer, setDealer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedDealer = localStorage.getItem("dealer");

    if (savedDealer) {
      try {
        const parsed = JSON.parse(savedDealer);
        if (parsed?.sessionToken) {
          setDealer(parsed);
        } else {
          // Legacy pre-session login state cannot access protected routes such
          // as Stock/Orders/Account. Force one clean login instead of leaving
          // the dealer on a page that repeatedly returns 401.
          localStorage.removeItem("dealer");
        }
      } catch (_) {
        localStorage.removeItem("dealer");
      }
    }

    setLoading(false);
  }, []);

  const handleLogin = (dealerData) => {
    setDealer(dealerData);
    localStorage.setItem("dealer", JSON.stringify(dealerData));
  };

  const handleLogout = async () => {
    try {
      await logoutUser();
    } catch (_) {
      // best-effort: still clear the local session even if the server call fails
    }
    setDealer(null);
    localStorage.removeItem("dealer");
  };

  if (loading) {
    return <p style={{ padding: "20px" }}>Loading...</p>;
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={
          dealer ? (
            <Navigate to="/dashboard" />
          ) : (
            <LoginPage onLogin={handleLogin} />
          )
        }
      />
      <Route
        path="/auth/wa"
        element={<WhatsAppLoginPage onLogin={handleLogin} />}
      />
      <Route
        path="/dashboard"
        element={
          dealer ? (
            <PartyDashboardPage dealer={dealer} onLogout={handleLogout} />
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/messages"
        element={dealer ? <DealerMessagesPage /> : <Navigate to="/login" />}
      />
      <Route
        path="/profile"
        element={dealer ? <ProfilePage dealer={dealer} onLogout={handleLogout} /> : <Navigate to="/login" />}
      />
      <Route
        path="/orders"
        element={dealer ? <OrdersPage dealer={dealer} /> : <Navigate to="/login" />}
      />
      <Route
        path="/stock"
        element={dealer ? <StockPage /> : <Navigate to="/login" />}
      />
      <Route
        path="/ledger"
        element={
          dealer ? (
            <LedgerPage dealer={dealer} />
          ) : (
            <Navigate to="/login" />
          )
        }
      />
      <Route
        path="/staff-access"
        element={dealer ? <StaffAccessPage /> : <Navigate to="/login" />}
      />
      <Route path="*" element={<Navigate to={dealer ? "/dashboard" : "/login"} />} />
    </Routes>
  );
}

export default App;